import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import styles from './Messages.module.scss';
import { useLayout } from '../../providers/Layout.provider';
import { useToken } from '../../providers/Token.provider';
import useFetchPaylinkSingleUseToken from '../../hooks/useApi/useFetchPaylinkSingleUseToken';
import useStorage from '../../hooks/useStorage';
import { useTranslation } from 'react-i18next';

const { Box, Title, Icon } = vp;

type FC = FunctionComponent;

const Declined: FC = () => {
  const { setLayoutInfo } = useLayout();
  const { token } = useToken();
  const storage = useStorage();
  const { Token } = storage.paylinkToken.getPaylinkToken();
  const [paymentText, setPaymentText] = useState('request');
  const [isLoading, setIsLoading] = useState(true);
  const [paylink, fetchSingleUseTokenInfo] = useFetchPaylinkSingleUseToken({});
  const { t } = useTranslation('translations', { keyPrefix: 'Error' });
  useEffect(() => {
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'curve',
      '',
      80,
      20,
      0,
      false,
      true,
    );
  }, []);

  useEffect(() => {
    fetchSingleUseTokenInfo({
      Token,
      ApplicationType: 'paylink',
    });
  }, [Token]);

  useEffect(() => {
    if (!paylink.Success) {
      return;
    }
    if (paylink?.ExtraInfo.PayLinkDetails.PaymentType === 'withdraw') {
      setPaymentText('payment');
    }
    if (paylink?.ExtraInfo.PayLinkDetails.PaymentType === 'fund') {
      setPaymentText('request of funds');
    }
    setIsLoading(false);
  }, [paylink]);

  if (isLoading) {
    return null;
  }

  if (
    paylink?.ExtraInfo.PayLinkDetails.Status === 'declined' ||
    paylink?.ExtraInfo.PayLinkDetails.Status === 'cancelled'
  ) {
    return (
      <div className={styles.errorMsgContainer}>
        <Box flx="col" height="auto" ai="center">
          <div className={styles.iconContainer}>
            <Icon icon="notAllowed" width="100%" height="100%" color="none" />
          </div>
          <Title title={t('declinedTitle', { defaultValue: 'Request Declined' })} size="lg" bold center />
          <div className={styles.text}>
            {t('declinedMessage', {
              paymentText,
              senderName: paylink.ExtraInfo.PayLinkDetails.SenderName,
              defaultValue:
                'You have declined the {{paymentText}} from <{{senderName}}>. If this was a mistake or you need assistance, please contact support',
            })}
          </div>
        </Box>
      </div>
    );
  }

  return (
    <div className={styles.errorMsgContainer}>
      <Box flx="col" height="auto" ai="center">
        <div className={styles.iconContainer}>
          <Icon icon="error3" width="100%" height="100%" color="none" />
        </div>
        <Title title={t('unsuccessfulTitle', { defaultValue: 'Transaction Unsuccessful' })} size="lg" bold center />
        {paylink.Success && (
          <div className={styles.text}>
            {t('unsuccessfulMessage', {
              senderName: paylink?.ExtraInfo.PayLinkDetails.SenderName,
              defaultValue:
                'We encountered an issue processing your payment due to an unexpected error. Please try again, or reach out to {{senderName}} Support for assistance.',
            })}
          </div>
        )}
      </Box>
    </div>
  );
};

export default Declined;
